
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/quick-call/[quick-call-id]/edit",
      function () {
        return require("private-next-pages/admin/quick-call/[quick-call-id]/edit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/quick-call/[quick-call-id]/edit"])
      });
    }
  